const metaNode = document.querySelector(
  'meta[name="0229446d125a944b391f0385ff2bfe04"]'
)
export default metaNode && metaNode.content
